import React, { useState } from "react";

const FAQAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const faqData = [
    {
      question: "What is FastFin?",
      answer: "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "What types of loans does fastfin offer?",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "Is there a loan application fee?",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "What types of loans does fastfin offer?",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "How quickly can I get approved for a loan?",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "Is my personal information secure with fastfin?",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "Can I check my loan status? ",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "Will I receive updates about my loan application status? ",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },
    {
      question: "How can I track my loan application status?",
      answer:
      "FastFin is a digital app that provides quick instant loans easily. Variety of loan options tailored for personal expenses, education, home renovations, medical bills, and more, Enabling you to move up in life. ",
    },     
  ];

  return (
    <div className="Accordian-main">
      <h2 className="accordian-heading">Frequently asked questions</h2>
      {faqData.map((item, index) => (
        <div className="acoordian-menu" key={index}>
          {/* Question Header */}
          <div
            onClick={() => toggleAccordion(index)}
            className='question-heading'           
          >
            <span>{item.question}</span>
            <span>
              {activeIndex === index ? "-" : "+"}
            </span>
          </div>

          {/* Answer Section */}
          {activeIndex === index && (
            <div className="accordian-answer">
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
